/**
* @render react
* @name EnhancedListItem
*/

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import { Image } from 'Components/atoms/Image';

/**
 * EnhancedListItem component
 * @param {string} title - Title of the element
 * @param {string} subtitle - Subtitle of the element
 * @param {string} excerpt - Excerpt of the element
 * @param {string} image - Object containing url of the image and alt text
 * @param {object} context - Extra information coming from Polaris provider.
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {object} extraClassNames - Extra class names to be applied to the component
 */
const EnhancedListItem = (
  {
    title,
    subtitle,
    excerpt,
    image,
    context: { cssPrefix },
    loadStyles,
    extraClassNames,
  },
) => (
  <div
    className={classNames({
      [`${cssPrefix}__enhanced-list-item`]: loadStyles,
      ...extraClassNames,
    })}
  >
    {image && image.src && <div className={`${cssPrefix}__enhanced-list-item--media`}><Image {...image} /></div>}

    <div className={`${cssPrefix}__enhanced-list-item--text`}>
      <h3 className={`${cssPrefix}__enhanced-list-item--title`}>{title}</h3>
      {subtitle && <h4 className={`${cssPrefix}__enhanced-list-item--subtitle`}>{subtitle}</h4>}
      {excerpt && <div className={`${cssPrefix}__enhanced-list-item--excerpt`}>{excerpt}</div>}
    </div>
  </div>
);

/**
 * Valid props
 */
EnhancedListItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  excerpt: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
};

/**
 * Default props
 */
EnhancedListItem.defaultProps = {
  title: '',
  subtitle: '',
  excerpt: '',
  image: {},
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(EnhancedListItem);
